import React from 'react'
import NotAllowedView from '../views/not-allowed'

const empty = (val) => (val.length === 0)

const AuthorisedGuard = ({loading = false, records = [], children}) => (
  !loading && empty(records) ?
    <NotAllowedView />
    : children
)
  
export default AuthorisedGuard


// WEBPACK FOOTER //
// ./src/layout/authorised-layout/authorised-guard/index.js